import errorHandler from '@core/lib/errorHandler/errorHandler';

export function ErrorHandlerService($provide: ng.auto.IProvideService) {
  $provide.decorator('$exceptionHandler', [
    '$delegate',
    ($delegate: ng.IExceptionHandlerService) => (error: Error, cause?: string) => {
      errorHandler.trackError(error);
      $delegate(error, cause);
    },
  ]);
}
